const config = {
  API_BASE_URL: process.env.NODE_ENV === 'production' 
    ? 'https://boldcompsolutions.com/backend/api' 
    : 'http://localhost/boldcomp-solutions/backend/api',

  SITE_BASE_URL: process.env.NODE_ENV === 'production'
    ? 'https://boldcompsolutions.com'
    : 'http://localhost/boldcomp-solutions',

  ADMIN_BASE_URL: process.env.NODE_ENV === 'production'
    ? 'https://boldcompsolutions.com/admin'
    : 'http://localhost/boldcomp-solutions/admin'
};

export default config;
